<template>
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    style="background: none; margin-bottom: 3px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0823 4.2334C18.1249 4.33223 18.1361 4.441 18.1145 4.54596C18.0929 4.65092 18.0394 4.74735 17.9608 4.82306L15.7108 6.98695C15.6584 7.03716 15.5963 7.07695 15.528 7.10405C15.4596 7.13116 15.3864 7.14504 15.3125 7.14492H12.1704L10.6483 8.60879C10.8198 8.95425 10.8589 9.34692 10.7585 9.7174C10.6582 10.0879 10.4249 10.4123 10.0999 10.6334C9.77483 10.8544 9.37901 10.9578 8.98237 10.9253C8.58572 10.8929 8.21378 10.7266 7.9323 10.4559C7.65081 10.1851 7.4779 9.82745 7.44413 9.44598C7.41035 9.06451 7.51789 8.68384 7.74773 8.37126C7.97757 8.05867 8.31492 7.83429 8.70014 7.73778C9.08537 7.64127 9.49367 7.67884 9.85288 7.84385L11.375 6.37998V3.35811C11.3749 3.28702 11.3893 3.2166 11.4175 3.15088C11.4457 3.08517 11.487 3.02543 11.5392 2.9751L13.7892 0.811213C13.8679 0.735361 13.9682 0.683683 14.0775 0.662729C14.1867 0.641775 14.3 0.65249 14.4029 0.693515C14.5058 0.734539 14.5937 0.804026 14.6555 0.893167C14.7173 0.982307 14.7502 1.08709 14.75 1.19422V3.89908H17.5625C17.6738 3.8991 17.7826 3.93088 17.8751 3.99039C17.9676 4.0499 18.0397 4.13447 18.0823 4.2334ZM16.2046 4.98103H14.1875C14.0383 4.98103 13.8952 4.92403 13.7898 4.82258C13.6843 4.72113 13.625 4.58353 13.625 4.44005V2.50013L12.5 3.58207V6.06297H15.0796L16.2046 4.98103ZM17.6829 6.62017C17.9697 7.46625 18.125 8.37076 18.125 9.3088C18.1246 11.1372 17.5221 12.9186 16.404 14.3973C15.2859 15.8761 13.7096 16.9764 11.9011 17.5404C10.0927 18.1044 8.14493 18.1031 6.33726 17.5368C4.52958 16.9704 2.95482 15.8681 1.8388 14.3878C0.722785 12.9076 0.122841 11.1255 0.125006 9.29707C0.12717 7.46865 0.731332 5.68786 1.85085 4.21006C2.97037 2.73226 4.54774 1.63337 6.35675 1.07098C8.16576 0.508588 10.1135 0.511583 11.9206 1.07954L11.0116 1.95375C9.34166 1.55775 7.58282 1.69844 6.00383 2.35434C4.42484 3.01023 3.11255 4.14524 2.26747 5.58596C1.42239 7.02668 1.09099 8.69386 1.32392 10.3328C1.55684 11.9717 2.34128 13.4922 3.55736 14.662C4.77345 15.8317 6.35431 16.5864 8.0584 16.8108C9.76248 17.0351 11.4961 16.7167 12.9943 15.9043C14.4925 15.0918 15.6729 13.83 16.3552 12.3115C17.0375 10.7931 17.1842 9.10159 16.7728 7.49547L17.6829 6.62017ZM14.6375 8.22686C14.8791 9.36622 14.7326 10.5501 14.2196 11.6031C13.7066 12.6561 12.8545 13.522 11.7895 14.0727C10.7246 14.6233 9.50353 14.8292 8.30732 14.66C7.11111 14.4908 6.00343 13.9554 5.14848 13.1331C4.29352 12.3109 3.73681 11.2456 3.56084 10.0952C3.38488 8.94476 3.59904 7.77042 4.17157 6.74624C4.74411 5.72205 5.64454 4.90255 6.73941 4.4092C7.83428 3.91585 9.0653 3.77491 10.25 4.00728V5.11735C9.29428 4.88023 8.28401 4.95189 7.37479 5.32127C6.46558 5.69065 5.70786 6.33728 5.21834 7.16154C4.72883 7.98581 4.53468 8.942 4.66579 9.88282C4.7969 10.8236 5.24601 11.6969 5.94393 12.3681C6.64185 13.0393 7.54987 13.4713 8.52814 13.5974C9.5064 13.7234 10.5006 13.5367 11.3577 13.0659C12.2148 12.5952 12.8871 11.8664 13.2712 10.992C13.6553 10.1176 13.7298 9.146 13.4832 8.22686H14.6375Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  data() {
    return {
      fill: "#878D99",
    };
  },
  mounted() {
    this.handleStyleIcon();
  },
  methods: {
    handleStyleIcon() {
      const isInOutReach = this.$route.path.includes("outreach");
      this.fill = isInOutReach ? "#1D57D8" : "#878D99";
    },
  },
  watch: {
    $route: {
      handler() {
        this.handleStyleIcon();
      },
      deep: true,
    },
  },
};
</script>

<style></style>
